module.exports = __webpack_public_path__ + "img/template2.d26b8aef.png";